import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'tasks',
    loadChildren: () => import('./steps/steps.module').then( m => m.StepsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'secure-email',
    loadChildren: () => import('./secure-email/secure-email.module').then( m => m.SecureEmailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'file-explorer',
    loadChildren: () => import('./file-explorer/file-explorer.module').then( m => m.FileExplorerPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'create-folder',
    loadChildren: () => import('./modals/files/create-folder/create-folder.module').then( m => m.CreateFolderPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'file-dropbox',
    loadChildren: () => import('./modals/files/file-dropbox/file-dropbox.module').then( m => m.FileDropboxPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'file',
    loadChildren: () => import('./pop-overs/files/file/file.module').then( m => m.FilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'folder',
    loadChildren: () => import('./pop-overs/files/folder/folder.module').then( m => m.FolderPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'folder-select-modal',
    loadChildren: () => import('./modals/files/folder-select-modal/folder-select-modal.module').then( m => m.FolderSelectModalPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'your-account',
    loadChildren: () => import('./your-account/your-account.module').then( m => m.YourAccountPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'your-account-settings',
    loadChildren: () => import('./modals/your-account/your-account-settings/your-account-settings.module').then( m => m.YourAccountSettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'comment',
    loadChildren: () => import('./modals/files/comment/comment.module').then( m => m.CommentPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./modals/files/settings/settings.module').then( m => m.SettingsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'search',
    loadChildren: () => import('./modals/files/search/search.module').then( m => m.SearchPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'file-select-modal',
    loadChildren: () => import('./modals/files/file-select-modal/file-select-modal.module').then( m => m.FileSelectModalPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'inbox',
    loadChildren: () => import('./inbox/inbox.module').then( m => m.InboxPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'email',
    loadChildren: () => import('./public/email/email.module').then( m => m.EmailPageModule)
  },
  {
    path: 'signature-request',
    loadChildren: () => import('./public/signature-request/signature-request.module').then( m => m.SignatureRequestPageModule)
  },
  {
    path: 'unlock-modal',
    loadChildren: () => import('./public/unlock-modal/unlock-modal.module').then( m => m.UnlockModalPageModule)
  },
  {
    path: 'survey',
    loadChildren: () => import('./public/survey/survey.module').then( m => m.SurveyPageModule)
  },
  {
    path: 'file-dropzone',
    loadChildren: () => import('./public/file-dropzone/file-dropzone.module').then( m => m.FileDropzonePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'appointments',
    loadChildren: () => import('./appointments/appointments.module').then( m => m.AppointmentsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'calendar',
    loadChildren: () => import('./calendar/calendar.module').then( m => m.CalendarPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'account-setup',
    loadChildren: () => import('./account-setup/account-setup.module').then( m => m.AccountSetupPageModule)
  },
    {
    path: 'approval-request',
    loadChildren: () => import('./public/approval-request/approval-request.module').then( m => m.ApprovalRequestPageModule)
  },
  {
    path: 'question-request',
    loadChildren: () => import('./public/question-request/question-request.module').then( m => m.QuestionRequestPageModule)
  },  {
    path: 'appointment-request',
    loadChildren: () => import('./public/appointment-request/appointment-request.module').then( m => m.AppointmentRequestPageModule)
  },
  {
    path: 'emails',
    loadChildren: () => import('./email/email.module').then( m => m.EmailPageModule),
    canActivate: [AuthGuard]
  },  {
    path: 'missing-info',
    loadChildren: () => import('./missing-info/missing-info.module').then( m => m.MissingInfoPageModule)
  },










];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
